import { useAuthContext } from './use-auth-context';

// ----------------------------------------------------------------------

/**
 * Display-oriented view of the signed-in user, derived from the app-provided
 * AuthContext value. Apps that enrich the user from another source (e.g. the
 * admin app's SQL Connect user row) do so in their AuthProvider, which keeps
 * this hook backend-agnostic.
 */
export function useCurrentUser() {
  const { user, loading } = useAuthContext();

  return {
    user: user
      ? {
          uid: user.uid ?? user.id,
          email: user.email ?? '',
          displayName: user.displayName ?? '',
          photoURL: user.photoURL ?? '',
          role: user.role,
        }
      : null,
    isPending: loading,
  };
}
